<script lang="ts">
  import { Plus, X } from '@lucide/svelte'
  import EmptyState from '../../../../components/empty-state/EmptyState.svelte'
  import PrinterPane from '../../../../components/printer-pane/PrinterPane.svelte'
  import usePrintersQueries from '../../hooks/usePrintersQueries'
  import i18n from '../../../../i18n'
  import useFilesQueries from '../../hooks/useFilesQueries'
  import File from '../../../../components/printer-pane/components/File.svelte'
  import { ThreeItemKeys } from '../../../../constants/three'

  type Props = {
    onRequestAddPrinter?: () => void
  }

  const { onRequestAddPrinter }: Props = $props()

  const { usePrinters } = usePrintersQueries()
  const printers = usePrinters()
  const { useFiles } = useFilesQueries()

  const filesQuery = useFiles()
  const unassignedFiles = $derived(
    filesQuery.data?.filter(
      file => !file.userData[ThreeItemKeys.ASSIGNED_PRINTER_ID],
    ) || [],
  )
</script>

{#if printers.data && printers.data.length > 0}
  <div class="main-container">
    <div class="printers-container">
      {#each printers.data || [] as printer (printer.uuid)}
        <PrinterPane id={printer.uuid} />
      {/each}
    </div>
    <div class="unassigned-files-container">
      <div class="header">
        {$i18n.t('project.leftBar.printers.unassignedFiles')}
        <span>{unassignedFiles?.length || 0}</span>
      </div>
      <div class="files">
        {#each unassignedFiles || [] as file (file.uuid)}
          <File fileId={file.uuid} noPadding />
        {/each}
      </div>
    </div>
  </div>
{:else}
  <div class="empty">
    <EmptyState
      buttonIcon={Plus}
      buttonLabel={$i18n.t('project.leftBar.printers.emptyState.buttonLabel')}
      icon={X}
      onButtonClick={onRequestAddPrinter}
      subtitle={$i18n.t('project.leftBar.printers.emptyState.subtitle')}
      title={$i18n.t('project.leftBar.printers.emptyState.title')}
    />
  </div>
{/if}

<style lang="scss">
  .printers-container {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
  }

  .empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
  }

  .main-container {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    overflow: hidden;
  }

  .unassigned-files-container {
    .header {
      padding: 1rem;
      font-size: 1rem;
      border-top: 1px solid var(--grid-stroke);
      border-bottom: 1px solid var(--grid-stroke);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      span {
        font-size: 0.875rem;
        color: var(--right-bar-muted-foreground);
      }
    }

    .files {
      overflow-y: auto;
      max-height: 14rem;
    }
  }
</style>
